module.exports = __webpack_public_path__ + "static/img/product_7.8416075.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_7.jpg
// module id = hGaT
// module chunks = 1